import { IDaDataAddress, IDaDataSuggestion } from '../../types/dadata';
import { IAddressSuggestion } from '../../types/address';

export const fromDadataToAddress = (dadataSuggest: IDaDataSuggestion<IDaDataAddress>[]): IAddressSuggestion[] => {
  return dadataSuggest.map(({ value, unrestricted_value, data: { house, fias_id, kladr_id, region_kladr_id } }) => ({
    displayName: value,
    name: unrestricted_value,
    hasHouse: Boolean(house),
    data: {
      address: unrestricted_value,
      displayName: value,
      fiasId: fias_id,
      kladrId: kladr_id,
      regionKladrId: region_kladr_id,
    },
  }));
};
